// ****** variables + selectors ******

var isMobile = false
var resizeTimer
var sidebarContent = $('.sidebar__content')
var sidebar = $('.sidebar')
var lastSidebarWidth = 0
var mobileBreakpoint = 576
var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
var scrollPos = 0


// ****** initialize ******

$(document).ready(function() {
  checkWindow()
  $('.size').on('click', handleSize)
  $('[data-sidebar-link]').on('click', handleSidebarLink, event)

  // when window finishes resizing, check to see if mobile bp or not
  $(window).on('resize', function (e) {
    clearTimeout(resizeTimer)
    resizeTimer = setTimeout(function () { 
      checkWindow() 
      if (!isMobile) {
        setSidebarHeight(sidebarContent.attr('data-active'))
      }
    }, 250)
  })

  $('.header__menu-link').on('click', handleMenuClick)
  $('.desc__btn').on('click', handleDetails)
  sidebar.on('transitionend', sidebarSlide, event)

  // loop through sizes and order incrementally
  sortSizes($('.size-wrap[data-parent="sidebar"]'))
  sortSizes($('.size-wrap[data-parent="product"]'))

  // --- ajax cart push complete ---
  $(document).on('cart.requestComplete', function (event, cart) {
    console.log('added to cart')
    if ($('.sidebar').attr('data-active') !== 'cart') {
      sidebarContent.attr('data-active', 'cart')
    }
    if (!isMobile) {
      setSidebarHeight('cart')
    }
    $('.header__cart').text(cart.item_count)
  })

  $(window).on('load', function () {
    if (!isMobile) {
      setSidebarHeight(sidebarContent.attr('data-active'))
    }
  })

  $(window).on('scroll', function(e) {
    if (isMobile) {
      handleScroll()
    }
  })

  $('.msg-wrap[data-target="filters"]').on('click', function(e) {
    $('html, body').animate({
      scrollTop: 0
    }, 750)
  })

  $('.msg-wrap[data-target="info"]').on('click', function(e) {
    var scrollPos = $('.product-info__wrapper').offset().top - $('.header').height()
    $('html, body').animate({
      scrollTop: scrollPos
    }, 750)
  })

  $('.email').focus(function() {
    this.value = ''
  })

  initCookies()

  if (isSafari) {
    if (!isMobile) {
      safariHeader()
    }
    else {
      safariOverlay()
    }
  }

})


// ****** functions ******

function safariHeader() {
  $('.sidebar__header').css({
    'position': 'relative',
    'width': 100 + '%'
  })
}

function safariOverlay() {
  if ($('.side-drawer').length > 0) {
    $('.side-drawer').css({
      'height': 100 + '%'
    })
  }
}

function checkWindow() {
  var ww = window.innerWidth
  if (ww <= mobileBreakpoint) { isMobile = true }
  else { isMobile = false }
}

function handleSize() {
  var selected = false
  var type = $(this).attr('id')
  var variantId = $(this).attr('data-variant-id')
  $('.size').not($(this)).removeClass('selected')
  if (type === 'product') {
    if (!$(this).hasClass('selected')) {
      $(this).addClass('selected')
    }
    var dropDown
    if (isMobile) {
      dropDown = $('#product__dropdown[data-parent="product"')
    }
    else {
      dropDown = $('#product__dropdown[data-parent="sidebar"')
    }
    var price = $(this).attr('data-price')
    var comparePrice = $(this).attr('data-compare-price')
    // set hidden input field to variant of div selected
    dropDown.val(variantId).change()
    $('.product-info__header #product-price').text(price)
    // if there is a compare price, set that too
    if (comparePrice.length > 0) {
      $('.product-info__header #product-compare-price').show().html('<s>' + comparePrice + '</s>')
    }
    else {
      $('.product-info__header #product-compare-price').hide().html('')
    }
  }
  else {
    // filter sizes in collection
    var size = $(this).attr('data-size')
    if (!$(this).hasClass('selected')) {
      $(this).addClass('selected')
      filterBySize(size)
    }
    else {
      $(this).removeClass('selected')
      removeSizeFilter()
    }
  }
}

// ...
function filterBySize(selectedSize) {
  $('.product-thumb').each(function (el, i) {
    var hasSize = false
    var thumb = $(this)
    var sizes = $(this).find('.product-thumb__sizes').children()
    sizes.each(function (size, x) {
      if (!$(this).hasClass('unavailable')) {
        if ($(this).html() === selectedSize) {
          hasSize = true
        }
      }
    })
    if (hasSize) {
      thumb.removeClass('hidden')
    }
    else {
      thumb.addClass('hidden')
    }
  })
}

function removeSizeFilter() {
  $('.product-thumb').each(function (el, i) {
    if ($(this).hasClass('hidden')) {
      $(this).removeClass('hidden')
    }
  })
}

// ...
function handleSidebarLink(e) {
  var activated = $(this).attr('data-sidebar-link')
  var active = sidebarContent.attr('data-active')
  if (!isMobile) {
    // if not cart link 
    if (!$(this).hasClass('header__cart')) {
      e.preventDefault()
    }
    else if ($(this).hasClass('cart-sidebar')) {
      e.preventDefault()
    }
    sidebarDesktop($(this), activated, active)
  }
  else {
    e.preventDefault()
    sidebarMobile($(this), activated, active)
  }
}

// handle sidebar nav for desktop
function sidebarDesktop(link, to, from) {
  // if clicked on same view as currently on 
  // e.g. clicking menu icon when data-active is already set to menu
  if (to === from) {
    if (sidebarContent.attr('data-page') === 'product') {
      sidebarContent.attr('data-active', 'product')
      setSidebarHeight('product')
    }
    else {
      sidebarContent.attr('data-active', 'menu')
      setSidebarHeight('menu')
    }
  }
  else {
    // if open shipping from sidebar
    if (to === 'shipping') {
      if (sidebar.attr('data-shipping-open') === 'true') {
        sidebar.width(lastSidebarWidth)
        sidebar.attr('data-shipping-open', 'false')
      }
      else {
        $('.sidebar__header')
        .removeClass('sidebar-visible')
        .addClass('sidebar-hidden')

        var sidebarWidth = sidebar.innerWidth()
        sidebar.width(parseInt(sidebarWidth))
        lastSidebarWidth = sidebarWidth

        setTimeout(function (e) { 
          sidebar.addClass('fixed')
          sidebar.attr('data-shipping-open', 'true')
        }, 100)
      }
    }
    else {
      if (to === 'guide') {
        console.log('open guide')
        if (sidebar.attr('data-guide-open') === 'true') {
          sidebar.width(lastSidebarWidth)
          sidebar.attr('data-guide-open', 'false')
        }
        else {
          $('.sidebar__header')
          .removeClass('sidebar-visible')
          .addClass('sidebar-hidden')

          var sidebarWidth = sidebar.innerWidth()
          sidebar.width(parseInt(sidebarWidth))
          lastSidebarWidth = sidebarWidth
          setTimeout(function (e) { 
            sidebar.addClass('fixed')
            sidebar.attr('data-guide-open', 'true')
          }, 100)
        }
      }
      else {
        if (to !== 'menu' && $('.header__menu-link').hasClass('open')) {
          $('.header__menu-link').removeClass('open')
        }
        sidebarContent.attr('data-active', to)
        if (to === 'menu') {
          setSidebarHeight(to)
        }
        else if (to === 'product') {
          setSidebarHeight(to)
        }
        else if (to === 'cart') {
          setSidebarHeight(to)
        }
      }
    }
  }
}

function handleSidebarMobile(dest) {
  if (dest === 'shipping') {
    if (sidebar.attr('data-shipping-open') === 'true') {
      sidebar.attr('data-shipping-open', 'false')
      $('.sidebar__shipping').removeClass('sidebar-visible').addClass('sidebar-hidden')
      $('.sidebar__content').removeClass('sidebar-hidden').addClass('sidebar-visible')
    }
    else {
      sidebar.attr('data-shipping-open', 'true')
      $('.sidebar__shipping').removeClass('sidebar-hidden').addClass('sidebar-visible')
      $('.sidebar__content').removeClass('sidebar-visible').addClass('sidebar-hidden')
      setTimeout(function() {
        $('.sidebar__shipping').scrollTop(0)
      }, 1)
    }
  }
  else if (dest === 'guide') {
    if (sidebar.attr('data-guide-open') === 'true') {
      sidebar.attr('data-guide-open', 'false')
      $('.sidebar__guide').removeClass('sidebar-visible').addClass('sidebar-hidden')
      $('.sidebar__content').removeClass('sidebar-hidden').addClass('sidebar-visible')
    }
    else {
      sidebar.attr('data-guide-open', 'true')
      $('.sidebar__guide').removeClass('sidebar-hidden').addClass('sidebar-visible')
      $('.sidebar__content').removeClass('sidebar-visible').addClass('sidebar-hidden')
      // throw to bottom of stack
      setTimeout(function() {
        $('.sidebar__guide').scrollTop(0)
      }, 1)
    }
  }
  else {
    sidebar.attr('data-shipping-open', 'false')
    sidebar.attr('data-guide-open', 'false')
    $('.sidebar__guide').removeClass('sidebar-visible').addClass('sidebar-hidden')
    $('.sidebar__shipping').removeClass('sidebar-visible').addClass('sidebar-hidden')
    $('.sidebar__content').removeClass('sidebar-hidden').addClass('sidebar-visible')
  }
}

// handle sidebar nav for mobile
function sidebarMobile(link, to, from) {
  console.log('sidebar mobile', link, to, from)
  if (sidebar.hasClass('open')) {
    if (to === from) {
      unlockScroll()
      $('body').removeClass('locked')
      sidebar.addClass('hidden').removeClass('open')
      handleSidebarMobile(to)
    }
    else {
      if (to !== 'menu' && $('.header__menu-link').hasClass('open')) {
        $('.header__menu-link').removeClass('open')
      }
      handleSidebarMobile(to)
      sidebarContent.attr('data-active', to)
    }
  }
  else {
    if (to === 'shipping') {
      handleSidebarMobile(to)
    }
    else if (to === 'guide') {
      handleSidebarMobile(to)
    }
    lockScroll()
    // $('body').addClass('locked')
    sidebar.removeClass('hidden').addClass('open')
    sidebarContent.attr('data-active', to)
  }
}


function lockScroll() {
  scrollPos = window.pageYOffset
  console.log('lock scroll', scrollPos)
  $('body').addClass('locked')
  $('body').css({
    top: `-${scrollPos}px`
  })
}

function unlockScroll() {
  console.log('unlock scroll', scrollPos)
  $('body').removeClass('locked')
  window.scrollTo(0, scrollPos);
}

function handleMenuClick() {
  if ($(this).hasClass('open')) {
    $(this).removeClass('open')
  }
  else {
    sidebar.attr('data-shipping-open', 'false')
    sidebar.attr('data-guide-open', 'false')
    $('.sidebar__content').removeClass('sidebar-hidden').addClass('sidebar-visible')
    $(this).addClass('open')
  } 
}

// ...
function sidebarSlide(e) {
  if (e.originalEvent.propertyName === 'width') {
    if ($(this).attr('data-shipping-open') === 'true') {
      $('.sidebar__shipping').removeClass('sidebar-hidden').addClass('sidebar-visible')
      $('.sidebar__guide').removeClass('sidebar-visible').addClass('sidebar-hidden')
      $('.sidebar__content').removeClass('sidebar-visible').addClass('sidebar-hidden')
    }
    else if ($(this).attr('data-guide-open') === 'true') {
      $('.sidebar__guide').removeClass('sidebar-hidden').addClass('sidebar-visible')
      $('.sidebar__shipping').removeClass('sidebar-visible').addClass('sidebar-hidden')
      $('.sidebar__content').removeClass('sidebar-visible').addClass('sidebar-hidden')
    }
    else {
      $(this).width('auto')
      $('.sidebar').removeClass('fixed')
      $('.sidebar__shipping').removeClass('sidebar-visible').addClass('sidebar-hidden')
      $('.sidebar__guide').removeClass('sidebar-visible').addClass('sidebar-hidden')
      $('.sidebar__header').removeClass('sidebar-hidden').addClass('sidebar-visible')
      $('.sidebar__content').removeClass('sidebar-hidden').addClass('sidebar-visible')
    }
  }
}

// ...
function handleDetails() {
  var details = $('.desc__details')
  if (details.hasClass('collapsed')) {
    details.removeClass('collapsed')
    $(this).removeClass('collapsed').find('span').text('Less')
  }
  else {
    details.addClass('collapsed')
    $(this).addClass('collapsed').find('span').text('Details')
  }
}

// order sizes incrementally
function sortSizes(el) {
  el.children().detach().sort(function (a, b) {
    var aSize = $(a).attr('data-size')
    var bSize = $(b).attr('data-size')
    if (bSize > aSize) {
      return -1
    }
    else if (bSize < aSize) {
      return 1
    }
    else {
      return 0
    }
  }).appendTo(el)
}


function setSidebarHeight(content) {
  var el 
  if (content === 'menu') {
    el = $('.sidebar__menu')
  }
  else if (content === 'product') {
    el = $('.sidebar__product-info')
  }
  else if (content === 'cart') {
    el = $('.sidebar__cart')
  }
}

function initCookies() {
  if (!localStorage.getItem('cookiesId')) {
    $('.msg-wrap[data-target="cookies"]').removeClass('hidden')
    $('.cookies-msg').on('click', function(e) {
      $('.msg-wrap[data-target="cookies"]').remove()
      localStorage.setItem('cookiesId', true)
    })
  }
  else {
    $('.msg-wrap[data-target="cookies"]').remove()
  }
}

function inViewport(el) {
  var elementTop = el.offset().top
  var elementBottom = elementTop + el.outerHeight()
  var viewportTop = $(window).scrollTop()
  var viewportBottom = viewportTop + $(window).height()
  return elementBottom > viewportTop && elementTop < viewportBottom
}

function handleScroll() {
  // if product page
  if ($('body').hasClass('product')) {
    handleAnchor($('.product-info__wrapper'), $('.msg-wrap[data-target="info"]'), $('.related-wrap'))
  }
  // if collection page
  else if ($('body').hasClass('collection')) {
    handleAnchor($('.collection-menu[data-parent="product"]'), $('.msg-wrap[data-target="filters"]'), $('.footer'))
  }
}

function handleAnchor(scrollTarget, cta, hideEl) {
  var footer = $('.footer')
  if (inViewport(scrollTarget) || inViewport(hideEl) || inViewport(footer)) {
    cta.addClass('hidden')
  }
  else {
    if (!inViewport(hideEl)) {
      cta.removeClass('hidden')
    }
    else {
      cta.addClass('hidden')
    }
  }
}

// set formatters for cart
rivets.formatters.color = function (title) {
  return title.split('-').splice(-1)
}

rivets.formatters.title = function (title) {
  return title.split('-')[0]
}

rivets.formatters.currency = function (value) {
  return '€' + (value / 100).toFixed(2)
}